var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3183_13799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8292 12.0021L12.8322 12.0016V7.60056C12.8322 5.44756 12.3687 3.78906 9.85166 3.78906C8.64166 3.78906 7.82966 4.45306 7.49816 5.08256H7.46316V3.99006H5.07666V12.0016H7.56166V8.03456C7.56166 6.99006 7.75966 5.98006 9.05316 5.98006C10.3277 5.98006 10.3467 7.17206 10.3467 8.10156V12.0021H12.8292Z",
    fill: "#AB854A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02979 3.99219H3.51779V12.0037H1.02979V3.99219Z",
    fill: "#AB854A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27254 0C1.47704 0 0.831543 0.6455 0.831543 1.441C0.831543 2.2365 1.47704 2.8955 2.27254 2.8955C3.06804 2.8955 3.71354 2.2365 3.71354 1.441C3.71304 0.6455 3.06754 0 2.27254 0Z",
    fill: "#AB854A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3183_13799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.831543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.df066990dfa2fd656793b7a2f2f05006.svg";
export { ForwardRef as ReactComponent };